<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13.767"
    height="13"
    viewBox="0 0 13.767 13"
  >
    <path
      d="M13.369,6.836,6.532,0,5.454,1.078,7.274,2.9,3.336,6.836a1.14,1.14,0,0,0,0,1.621l4.206,4.206a1.145,1.145,0,0,0,1.621,0l4.206-4.206A1.14,1.14,0,0,0,13.369,6.836Zm-8.679.811L8.352,3.984l3.663,3.663ZM15.235,8.794s-1.529,1.659-1.529,2.676a1.529,1.529,0,0,0,3.059,0C16.764,10.454,15.235,8.794,15.235,8.794Z"
      transform="translate(-2.998)"
    />
  </svg>
</template>

<script>
export default {
  name: 'FillIcon',
};
</script>
